export default "__VITE_ASSET__bd361ed0__"